// import CreateExternalEvent from "module/admin/pages/createExternalEvent/view";
// import BusinessActivityRequestsBuyer from "module/buyer/pages/business-activity-requests/view";
// import ContactRequestsPageBuyer from "module/buyer/pages/contact-requests/view";
// import OrganizationPage from "module/admin/pages/organization/view/getOrganization";
// import BusinessActivityDetailsBuyer from "module/buyer/pages/business-activity/view/components/BusinessActivityDetailsBuyer";
// import ConfirmationScreen from "module/registration/pages/view/components/ConfirmationScreen";
// import EventsAdmin from "module/admin/pages/events/view";
// import BusinessActivityDetailsSeller from "module/seller/pages/business-activity-detail/view";
// import BusinessActivityRequests from "module/seller/pages/business-activity/business-activity-requests/view";
// import ContactRequestsPage from "module/seller/pages/contact-requests/view";
import { lazy, Suspense } from "react";
import Screenloader from "commons/components/ScreenLoader";
import LeadVerificationSeller from "../../module/seller/pages/lead-verification/view";

// Admin Routes
// =====================
// ADMIN ROUTES
// =====================
const AnnouncementPage = lazy(
  () => import("module/admin/pages/announcement/view"),
);
const Approvals = lazy(() => import("module/admin/pages/approvals/view"));
const BusinessActivitiesAdmin = lazy(
  () => import("module/admin/pages/businessActivities/view"),
);
const DashboardAdmin = lazy(() => import("module/admin/pages/dashboard/view"));
const EventDetailsAdmin = lazy(
  () => import("module/admin/pages/event-details/view"),
);
const EventsAdmin = lazy(() => import("module/admin/pages/events/view"));
const EditCompanyPage = lazy(
  () => import("module/admin/pages/organization/view/editOrganization/index"),
);
const EditUserPage = lazy(
  () => import("module/admin/pages/users/view/editUsers"),
);
const GetUsers = lazy(() => import("module/admin/pages/users/view/getUsers"));
const ApproveUserPage = lazy(
  () => import("module/admin/pages/approveUser/view"),
);
const AddExhibitorPage = lazy(
  () => import("module/admin/pages/addExhibitor/view/index"),
);
const AddBuyersPage = lazy(
  () => import("module/admin/pages/addAttendee/view/index"),
);
const CreateEvent = lazy(() => import("module/admin/pages/createEvent/view"));
const CreateExternalEvent = lazy(
  () => import("module/admin/pages/createExternalEvent/view"),
);
const NewCreateEvent = lazy(
  () => import("module/admin/pages/newCreateEvent/view"),
);
const OrganizationPage = lazy(
  () => import("module/admin/pages/organization/view/getOrganization"),
);
const AddFamTripPartnerPage = lazy(
  () => import("module/admin/pages/addFamTripPartner/view"),
);
const AddDelegatePage = lazy(
  () => import("module/admin/pages/addDelegate/view/index"),
);
const SecurityManagementPage = lazy(
  () => import("../../module/admin/pages/SecurityManagementPage/view"),
);
const AddSecurityPage = lazy(
  () => import("../../module/admin/pages/addSecurity/view"),
);
const AddHostedDelegatePage = lazy(
  () => import("module/admin/pages/addHostedDelegate/view"),
);
const AddNetworkingUsersPage = lazy(
  () => import("module/admin/pages/addNetworkingUsers/view"),
);

const EventMailConfig = lazy(
  () => import("commons/components/EventDetail/EventMailConfig/view"),
);

// =====================
// BUYER ROUTES
// =====================
const DashboardBuyer = lazy(() => import("module/buyer/pages/dashboard/view"));
const EventsBuyer = lazy(() => import("module/buyer/pages/events/view"));
const ContactsBuyer = lazy(() => import("module/buyer/pages/contacts/view"));
const BusinessActivitiesBuyer = lazy(
  () => import("module/buyer/pages/business-activity/view"),
);
const EventDetailsBuyer = lazy(
  () => import("module/buyer/pages/event-details/view"),
);
const BusinessActivityDetailsBuyer = lazy(
  () =>
    import("module/buyer/pages/business-activity/view/components/BusinessActivityDetailsBuyer"),
);
const BusinessActivityRequestsBuyer = lazy(
  () => import("module/buyer/pages/business-activity-requests/view"),
);
const ContactRequestsPageBuyer = lazy(
  () => import("module/buyer/pages/contact-requests/view"),
);

// =====================
// SELLER ROUTES
// =====================
const DashboardSeller = lazy(
  () => import("module/seller/pages/dashboard/view"),
);
const EventsSeller = lazy(() => import("module/seller/pages/events/view"));
const ContactsSeller = lazy(() => import("module/seller/pages/contacts/view"));
const MeetingSchedulerSeller = lazy(
  () => import("module/seller/pages/calendar/view"),
);
const BusinessActivitiesSeller = lazy(
  () => import("module/seller/pages/business-activity/view"),
);
const EventDetailsSeller = lazy(
  () => import("module/seller/pages/event-details/view"),
);
const BusinessActivityDetailsSeller = lazy(
  () => import("module/seller/pages/business-activity-detail/view"),
);
const BusinessActivityRequestsSeller = lazy(
  () => import("module/seller/pages/business-activity-requests/view"),
);
const ContactRequestsPageSeller = lazy(
  () => import("module/seller/pages/contact-requests/view"),
);
const MeetingVerificationSeller = lazy(
  () => import("module/seller/pages/meeting-verification/view"),
);

// =====================
// SECURITY ROUTES
// =====================

const EventsPageSecurity = lazy(
  () => import("module/security/pages/events/view"),
);
const EventDetailsPageSecurity = lazy(
  () => import("module/security/pages/event-details/view"),
);

// =====================
// OTHER / SHARED ROUTES
// =====================
const CalendarManagement = lazy(
  () => import("module/calendar-management/view"),
);
const LoginPage = lazy(() => import("module/login/pages/view"));
const Registration = lazy(() => import("module/registration/pages/view"));
// const ConfirmationScreen = lazy(() =>
//   import("module/registration/pages/view/components/ConfirmationScreen")
// );
const ProfilePage = lazy(() => import("module/profile/view"));
const AuthenticatingPage = lazy(() => import("module/AuthenticatingPage/view"));
const AdminLoginPage = lazy(() => import("module/admin-login/pages/view"));
const CheckedInPage = lazy(
  () => import("../../commons/components/EventCheckInStats"),
);

const MeetingConfirmationPage = lazy(
  () => import("../../pages/meeting-confirmation/view"),
);
// const Screenloader = lazy(() => import("commons/components/ScreenLoader"));
const PrivacyPolicy = lazy(() => import("commons/components/ui/PrivacyPolicy"));
const NetworkingCalendarManagement = lazy(
  () => import("module/networking-calendar-management/view"),
);
const PublicEventPage = lazy(() => import("pages/public-event/view"));
const ActivityVerificationPage = lazy(
  () => import("pages/activity-verification/view/index.jsx"),
);
const CounterpartDetail = lazy(
  () => import("module/ai-matchmaking/view/components/CounterpartDetail"),
);
const LandingPage = lazy(() => import("module/landing/view/index.jsx"));
// import CreateEvent from "module/admin/pages/CreateEvent/view";

const Loadable = (Component) => (
  <Suspense fallback={<Screenloader />}>{Component}</Suspense>
);

// const adminRoutes = [
//   { path: "/", component: <DashboardAdmin /> },
//   { path: "/dashboard", component: <DashboardAdmin /> },
//   { path: "/events", component: <EventsAdmin /> },
//   // { path: "/business-activity", component: <BusinessActivitiesAdmin /> },
//   { path: "/event-details", component: <EventDetailsAdmin /> },
//   // { path: "/create-event", component: <CreateEvent /> },
//   { path: "/create-event", component: <CreateEvent /> },
//   { path: "/approvals", component: <Approvals /> },
//   { path: "approvals/:id", component: <ApproveUserPage /> },
//   { path: "/users", component: <GetUsers /> },
//   // { path: "/announcement", component: <AnnouncementPage /> },
//   { path: "/add-exhibitor", component: <AddExhibitorPage /> },
//   { path: "/add-attendee", component: <AddBuyersPage /> },
//   // { path: "/buyer-calendar", component: <AdminCalendar /> },
//   { path: "/seller-calendar", component: <CalendarManagement /> },

//   { path: "/:id/edit-user", component: <EditUserPage /> },
//   { path: "/:id/edit-company", component: <EditCompanyPage /> },
//   { path: "/profile", component: <ProfilePage /> },
// ];
const adminRoutes = [
  { path: "/", component: Loadable(<LoginPage />) },
  { path: "/dashboard", component: Loadable(<DashboardAdmin />) },
  { path: "/events", component: Loadable(<EventsAdmin />) },
  { path: "/event-details", component: Loadable(<EventDetailsAdmin />) },
  { path: "/events/:eventSlug", component: Loadable(<EventDetailsAdmin />) },
  {
    path: "/events/:eventSlug/:tab",
    component: Loadable(<EventDetailsAdmin />),
  },
  {
    path: "/events/:eventSlug/:tab/:rsvpTab",
    component: Loadable(<EventDetailsAdmin />),
  },
  { path: "/create-event", component: Loadable(<CreateEvent />) },
  { path: "/create-event-new", component: Loadable(<NewCreateEvent />) },
  { path: "/approvals", component: Loadable(<Approvals />) },
  { path: "approvals/:id", component: Loadable(<ApproveUserPage />) },
  { path: "/users", component: Loadable(<GetUsers />) },
  { path: "/organizations", component: Loadable(<OrganizationPage />) },
  { path: "/add-exhibitor", component: Loadable(<AddExhibitorPage />) },
  { path: "/add-attendee", component: Loadable(<AddBuyersPage />) },
  {
    path: "/add-fam-trip-partner",
    component: Loadable(<AddFamTripPartnerPage />),
  },
  { path: "/add-delegate", component: Loadable(<AddDelegatePage />) },
  {
    path: "/add-hosted-delegate",
    component: Loadable(<AddHostedDelegatePage />),
  },
  {
    path: "/add-networking-delegate",
    component: Loadable(<AddNetworkingUsersPage />),
  },
  { path: "/seller-calendar", component: Loadable(<CalendarManagement />) },
  { path: "/buyer-calendar", component: Loadable(<CalendarManagement />) },
  { path: "/edit-user/:id", component: Loadable(<EditUserPage />) },
  { path: "/edit-company/:id", component: Loadable(<EditCompanyPage />) },
  { path: "/profile/:id", component: Loadable(<ProfilePage />) },
  { path: "/profile/:id/:tab", component: Loadable(<ProfilePage />) },
  {
    path: "/create-external-event",
    component: Loadable(<CreateExternalEvent />),
  },
  {
    path: "/contact-directory-buyer/:id",
    component: Loadable(<ContactsBuyer />),
  },
  {
    path: "/contact-directory-seller/:id",
    component: Loadable(<ContactsBuyer />),
  },
  {
    path: "/business-activities/:id",
    component: Loadable(<BusinessActivityDetailsBuyer />),
  },
  {
    path: "/buyer-networking-calendar",
    component: Loadable(<NetworkingCalendarManagement />),
  },
  {
    path: "/seller-networking-calendar",
    component: Loadable(<NetworkingCalendarManagement />),
  },
  {
    path: "/email-drafts",
    component: Loadable(<EventMailConfig />),
  },
  { path: "/security", component: Loadable(<SecurityManagementPage />) },
  { path: "/add-security", component: Loadable(<AddSecurityPage />) },
  { path: "/check-in-stats", component: Loadable(<CheckedInPage />) },
  { path: "/counterpart-detail", component: Loadable(<CounterpartDetail />) },
  { path: "/view-user/:id", component: Loadable(<EditUserPage />) },
];

// const buyerRoutes = [
//   { path: "/", component: <DashboardBuyer /> },
//   { path: "/dashboard", component: <DashboardBuyer /> },
//   { path: "/events", component: <EventsBuyer /> },
//   { path: "/contact-directory", component: <ContactsBuyer /> },
//   // { path: "/meeting-scheduler", component: <MeetingSchedulerBuyer /> },
//   // {
//   //   path: "/calendarview",
//   //   component: (
//   //     <CalendarView
//   //       userRole="seller"
//   //       isPrimaryContact={false}
//   //       eventData={newEventData}
//   //     />
//   //   ),
//   // },
//   // { path: "/business-activity", component: <BusinessActivitiesBuyer /> },
//   { path: "/event-details", component: <EventDetailsBuyer /> },
//   { path: "/profile", component: <ProfilePage /> },
// ];

const buyerRoutes = [
  { path: "/", component: Loadable(<EventsBuyer />) },
  // { path: "/dashboard", component: Loadable(<DashboardBuyer />) },
  { path: "/events", component: Loadable(<EventsBuyer />) },
  { path: "/contact-directory", component: Loadable(<ContactsSeller />) },
  { path: "/leads", component: Loadable(<ContactsSeller />) },
  // { path: "/event-details", component: Loadable(<EventDetailsBuyer />) },
  { path: "/event-details", component: Loadable(<EventDetailsSeller />) },
  { path: "/events/:eventSlug", component: Loadable(<EventDetailsSeller />) },
  {
    path: "/events/:eventSlug/:tab",
    component: Loadable(<EventDetailsSeller />),
  },
  {
    path: "/events/:eventSlug/:tab/:rsvpTab",
    component: Loadable(<EventDetailsSeller />),
  },

  { path: "/profile/:id", component: Loadable(<ProfilePage />) },
  { path: "/profile/:id/:tab", component: Loadable(<ProfilePage />) },
  { path: "/view-user/:id", component: Loadable(<EditUserPage />) },
  { path: "/view-company/:id", component: Loadable(<EditCompanyPage />) },
  {
    path: "/business-activity",
    component: Loadable(<BusinessActivitiesBuyer />),
  },
  {
    path: "/business-activities/:id",
    component: Loadable(<BusinessActivityDetailsBuyer />),
  },
  // { path: "/requests", component: <ContactRequestsPageBuyer /> },
  { path: "/requests", component: Loadable(<ContactRequestsPageSeller />) },
  // {
  //   path: "/activity-requests",
  //   component: Loadable(<BusinessActivityRequestsBuyer />),
  // },
  { path: "/check-in-stats", component: Loadable(<CheckedInPage />) },

  {
    path: "/business-activity/create",
    component: Loadable(<BusinessActivitiesBuyer />),
  },

  {
    path: "/business-activity/edit/:id",
    component: Loadable(<BusinessActivitiesBuyer />),
  },

  {
    path: "/business-activity/:id",
    component: Loadable(<BusinessActivityDetailsBuyer />),
  },
  { path: "/counterpart-detail", component: Loadable(<CounterpartDetail />) },
  { path: "/add-exhibitor", component: Loadable(<AddExhibitorPage />) },
  { path: "/add-attendee", component: Loadable(<AddBuyersPage />) },
  {
    path: "/add-networking-delegate",
    component: Loadable(<AddNetworkingUsersPage />),
  },
  {
    path: "/add-hosted-delegate",
    component: Loadable(<AddHostedDelegatePage />),
  },
  {
    path: "/add-fam-trip-partner",
    component: Loadable(<AddFamTripPartnerPage />),
  },
  { path: "/seller-calendar", component: Loadable(<CalendarManagement />) },
  { path: "/buyer-calendar", component: Loadable(<CalendarManagement />) },
];

// const sellerRoutes = [
//   { path: "/", component: <DashboardSeller /> },
//   { path: "/dashboard", component: <DashboardSeller /> },
//   { path: "/events", component: <EventsSeller /> },
//   { path: "/contact-directory", component: <ContactsSeller /> },
//   // { path: "/meeting-scheduler", component: <MeetingSchedulerSeller /> },
//   // { path: "/business-activity", component: <BusinessActivitiesSeller /> },
//   { path: "/event-details", component: <EventDetailsSeller /> },
//   { path: "/profile", component: <ProfilePage /> },
// ];

const sellerRoutes = [
  { path: "/", component: Loadable(<EventsSeller />) },
  // { path: "/dashboard", component: Loadable(<DashboardSeller />) },
  { path: "/events", component: Loadable(<EventsSeller />) },
  { path: "/contact-directory", component: Loadable(<ContactsSeller />) },
  { path: "/leads", component: Loadable(<ContactsSeller />) },
  { path: "/event-details", component: Loadable(<EventDetailsSeller />) },
  { path: "/events/:eventSlug", component: Loadable(<EventDetailsSeller />) },
  {
    path: "/events/:eventSlug/:tab",
    component: Loadable(<EventDetailsSeller />),
  },
  {
    path: "/events/:eventSlug/:tab/:rsvpTab",
    component: Loadable(<EventDetailsSeller />),
  },
  { path: "/profile/:id", component: Loadable(<ProfilePage />) },
  { path: "/profile/:id/:tab", component: Loadable(<ProfilePage />) },
  { path: "/seller-calendar", component: Loadable(<CalendarManagement />) },
  { path: "/view-user/:id", component: Loadable(<EditUserPage />) },
  { path: "/view-company/:id", component: Loadable(<EditCompanyPage />) },
  {
    path: "/business-activity",
    component: Loadable(<BusinessActivitiesSeller />),
  },
  {
    path: "/business-activity/create",
    component: Loadable(<BusinessActivitiesSeller />),
  },
  {
    path: "/business-activity/edit/:id",
    component: Loadable(<BusinessActivitiesSeller />),
  },
  {
    path: "/business-activity/:id",
    component: Loadable(<BusinessActivitiesSeller />),
  },
  {
    path: "/business-activities/:id",
    component: Loadable(<BusinessActivityDetailsSeller />),
  },
  { path: "/requests", component: Loadable(<ContactRequestsPageSeller />) },
  {
    path: "/activity-requests",
    component: Loadable(<BusinessActivityRequestsSeller />),
  },
  { path: "/check-in-stats", component: Loadable(<CheckedInPage />) },
  {
    path: "/meeting-verification",
    component: Loadable(<MeetingVerificationSeller />),
  },
  {
    path: "/lead-verification",
    component: Loadable(<ContactsSeller />),
  },
  { path: "/counterpart-detail", component: Loadable(<CounterpartDetail />) },
  { path: "/add-exhibitor", component: Loadable(<AddExhibitorPage />) },
  { path: "/add-attendee", component: Loadable(<AddBuyersPage />) },
  {
    path: "/add-networking-delegate",
    component: Loadable(<AddNetworkingUsersPage />),
  },
  {
    path: "/add-hosted-delegate",
    component: Loadable(<AddHostedDelegatePage />),
  },
  {
    path: "/add-fam-trip-partner",
    component: Loadable(<AddFamTripPartnerPage />),
  },
  { path: "/seller-calendar", component: Loadable(<CalendarManagement />) },
  { path: "/buyer-calendar", component: Loadable(<CalendarManagement />) },
];

const securityRoutes = [
  { path: "/dashboard", component: Loadable(<EventsPageSecurity />) },
  { path: "/events", component: Loadable(<EventsPageSecurity />) },
  {
    path: "/events/:eventSlug",
    component: Loadable(<EventDetailsPageSecurity />),
  },
  {
    path: "/events/:eventSlug/:tab",
    component: Loadable(<EventDetailsPageSecurity />),
  },
];
// const publicRoutes = [
//   { path: "/login", component: <LoginPage /> },
//   { path: "/registration", component: <Registration /> },
//   { path: "/authenticate", component: <AuthenticatingPage /> },
//   { path: "/admin-login", component: <AdminLoginPage /> },
// ];

const publicRoutes = [
  {
    path: "/",
    component: Loadable(<LandingPage />),
  },
  { path: "/login", component: Loadable(<LoginPage />) },
  { path: "/registration", component: Loadable(<Registration />) },
  // `requiresLoggedOut: false` keeps this route OUTSIDE PublicOnlyRoute.
  // Otherwise, the moment useAuthenticate sets isAuthenticated = true,
  // PublicOnlyRoute would immediately <Navigate> to /events (or /dashboard),
  // flashing the Events page before useAuthenticate navigates to the real
  // destination. Opting out lets useAuthenticate perform the single,
  // authoritative redirect while the loader stays mounted.
  {
    path: "/authenticate",
    component: Loadable(<AuthenticatingPage />),
    requiresLoggedOut: false,
  },
  { path: "/admin-login", component: Loadable(<AdminLoginPage />) },
  { path: "/privacy-policy", component: Loadable(<PrivacyPolicy />) },
  // { path: "/event/:eventId", component: Loadable(<PublicEventPage />) },
  { path: "/event/:slug", component: Loadable(<PublicEventPage />) },
  {
    path: "/event-meeting",
    component: Loadable(<MeetingConfirmationPage />),
  },
  {
    path: "/networking-meeting",
    component: Loadable(<MeetingConfirmationPage />),
  },
  {
    path: "/activity-verification",
    component: Loadable(<ActivityVerificationPage />),
  },

  // { path: "/event-confirmation", component: Loadable(<PublicEventPage />) },

  // { path: "/confirmation", component: Loadable(<ConfirmationScreen />) },
];

export { adminRoutes, buyerRoutes, sellerRoutes, publicRoutes, securityRoutes };
